// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2T0xs","comment":"styles_comment__3--7r"};